import { ReactComponent as NextIcon } from '@paradigm/icons/src/mailru/navigation/arrow_list_next.svg';
import React, { FC } from 'react';

import styles from './BackButton.css';

export interface BackButtonProps {
    hook: () => {
        onClose: () => void;
    };
}

export const BackButton: FC<BackButtonProps> = ({ hook }) => {
    const { onClose } = hook();
    return <NextIcon className={styles.icon} width={12} height={12} onClick={onClose} />;
};
